import {useEffect, useState} from "react";

function getAvailableHeight(parentRef, childRef) {
    if (parentRef.current && childRef.current) {
        const {current: parentElement} = parentRef;
        const {current: childElement} = childRef;
        const otherChildren = parentElement.querySelectorAll(`#${parentElement.id} > :not(#${childElement.id})`);
        const childrenHeight = Array.from(otherChildren).reduce((height, child) => height + child.clientHeight, 0);
        return {available: parentElement.clientHeight - childrenHeight, max: parentElement.clientHeight};
    }

    return {available: 0, max: 0};
}

export default function useAvailableHeight(parentRef, childRef) {
    const [availableHeight, setAvailableHeight] = useState(getAvailableHeight(parentRef, childRef));

    useEffect(() => {
        function handleHeightChange() {
            setAvailableHeight(getAvailableHeight(parentRef, childRef));
        }

        // Call once to properly initialize (the references probably won't change)
        handleHeightChange();

        window.addEventListener('resize', handleHeightChange);
        return function cleanup() {
            window.removeEventListener('resize', handleHeightChange);
        }
    }, [childRef, parentRef]);

    return availableHeight;
}